import { render } from "./motionBucketDownloadDetail.vue?vue&type=template&id=77fd81f6&scoped=true"
import script from "./motionBucketDownloadDetail.vue?vue&type=script&lang=js"
export * from "./motionBucketDownloadDetail.vue?vue&type=script&lang=js"

import "./motionBucketDownloadDetail.vue?vue&type=style&index=0&id=77fd81f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77fd81f6"]])

export default __exports__